
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlobViewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnippetBlobViewer"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collapsed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"renderError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tooLarge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileType"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":100}};
    doc.loc.source = {"body":"fragment BlobViewer on SnippetBlobViewer {\n  collapsed\n  renderError\n  tooLarge\n  type\n  fileType\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
